import React from 'react';

import { Box, Button } from '@mui/material';

export default function LoginDialog() {

    return (
        <Box sx={{ width: '100%' }}>
            <p>Välkommen till Eko, Snättringe SKs ekonomisystem!</p>
            <p>Man loggar in med sitt Visma-konto och man måste godkänna att Eko får åtkomst till "eAccounting API" och "eAccounting accounting readonly" för det företag man vill arbeta med.
            </p>
            <Button variant="contained" href="/auth/login">Logga in</Button>
        </Box>
    )
}
